import React from "react";
import { graphql } from "gatsby";
import Layout from "../components/App/Layout";
import { useTranslation } from "../plugins/i18next/ea-react-i18next";
import SEO from "../components/App/SEO";
import img8 from '../assets/images/easylife365/monstaintro.png'


export const Head = () => {
  return <SEO title='notFound.title' description='notFound.description' />;
};

 const NotFoundPage = () => {
    const { t } = useTranslation("pages");
    
    return <Layout>
           <div className="page-title-area">
            <div className="container-fluid hero-container">
                <div className="page-title-content">
                    <h2>{t("notFound.message")}</h2>
                </div>
                <div className="col-lg-6 col-md-12 pt-70">
                  <img src={img8} alt="image" className="chaosmonsta"/>
                </div>
            </div>
        </div>     
    </Layout>
};

export default NotFoundPage;

export const query = graphql`
query ($language: String) {
  locales: allLocale(filter: {language: {eq: $language}, ns: {in: ["components","pages"]}}) {
    edges {
      node {
        ns
        language
        data
      }
    }
  }
}
`;